import { takeLatest, call, all } from "redux-saga/effects";
import { getReceiverWorker } from "services/Receiver/sagas";
import { getValidatorsObjectProperties } from "services/ValidatorsForObjectProperties/sagas";
import { initObjectStructuresModule } from "modules/ObjectStructures/services/initialization/actions";

function* activeModuleWorker (){
    yield all([
        call(getReceiverWorker),
        call(getValidatorsObjectProperties),
    ]);
}

export function* initObjectStructures() {
    yield all([
        yield takeLatest(initObjectStructuresModule, activeModuleWorker)
    ]);
}
